import { pontoTipo } from '../types/Ponto.ts';
import type { PontoTipo } from '../types/Ponto.ts';
import type { PontoEvent } from '../types/PontoEvent.ts';
import { Parser } from './Parser.ts';

function parsePontoTipo(raw: unknown): PontoTipo {
    // Normalize
    const v =
        typeof raw === 'string' ? Number(raw) :
        raw instanceof Number ? raw.valueOf() :
        raw;

    if (typeof v !== 'number' || !Number.isInteger(v)) {
        throw new Error(`PontoTipo must be an integer number. Got: ${String(raw)}`);
    }

    const allowed = Object.values(pontoTipo); // [0,1,2]
    if (!allowed.includes(v as PontoTipo)) {
        throw new Error(`Unknown PontoTipo value: ${v}`);
    }

    return v as PontoTipo; // compile-time assertion only
}

export class PontoEventParser extends Parser<PontoEvent> {
    public parse(input: { dataHora: string | Date; tipo: number }): PontoEvent {
        // Implement parsing logic here
        return {
            dataHora: new Date(input.dataHora),
            tipo: parsePontoTipo(input.tipo)
        };
    }
}
